enum DriverLicenseEnum {
    None, A, B, C, D, E
}

export default DriverLicenseEnum;